<template>
  <v-card class="pa-6" elevation="0">
    <v-row>
      <v-col cols="12" sm="6">
        <AutocompleteClass
          v-model="selectedClass"
          label="Lớp học"
          placeholder="Nhập tên lớp học"
          @change="onClassChange"
          outlined
          dense
          hide-details="auto"
          class="mb-4"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="selectedLessons"
          :items="lessonOptions"
          label="Buổi học"
          outlined
          dense
          hide-details="auto"
          multiple
          chips
          :disabled="!selectedClass"
          class="mb-4"
          @change="onLessonsChange"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
              <span>{{ item.text }}</span>
            </v-chip>
            <span v-if="index === 0 && selectedLessons.length > 1" class="grey--text text-caption">
              (+{{ selectedLessons.length - 1 }} buổi khác)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <div class="d-flex justify-end">
      <v-btn color="primary" @click="onSearch" :disabled="!isSearchEnabled" :loading="loading" elevation="0">
        <v-icon left>mdi-magnify</v-icon>
        Tìm kiếm
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass.vue'

export default {
  components: {
    AutocompleteClass,
  },
  data() {
    return {
      selectedClass: null,
      selectedLessons: [],
      lessonOptions: [],
    }
  },
  computed: {
    ...mapState('evaluate', ['loading', 'error']),
    isSearchEnabled() {
      return this.selectedClass && this.selectedLessons.length > 0
    },
  },
  methods: {
    ...mapActions('evaluate', ['fetchEvaluates']),
    ...mapActions('lesson', ['fetchLessons']),
    async onClassChange(selectedClass) {
      this.selectedClass = selectedClass
      this.selectedLessons = []
      if (selectedClass) {
        await this.loadLessons()
      } else {
        this.lessonOptions = []
      }
    },
    async loadLessons() {
      try {
        const lessons = await this.fetchLessons({ class: this.selectedClass.id })
        this.lessonOptions = lessons.map((lesson) => ({
          text: `${lesson.classTitle} - ${lesson.startTime} - ${new Date(lesson.date)
            .toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' })
            .split('/')
            .join('/')}`,
          value: lesson._id,
        }))
      } catch (error) {
        console.error('Error fetching lessons:', error)
      }
    },
    onLessonsChange(selectedLessons) {
      this.selectedLessons = selectedLessons
    },
    async onSearch() {
      try {
        const params = {
          class: this.selectedClass ? this.selectedClass.id : undefined,
          lessons: this.selectedLessons,
        }
        this.$emit('search', params)
      } catch (error) {
        console.error('Error fetching evaluates:', error)
      }
    },
  },
}
</script>
